import { render, staticRenderFns } from "./foreigner-form.vue?vue&type=template&id=0532cb7a&"
import script from "./foreigner-form.vue?vue&type=script&lang=js&"
export * from "./foreigner-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports